/** 風向計（docs/06_ui-ux.md 2 章）。3D 画面の右上。カメラの向きに合わせて回り、今いる場所の実際の風を示す */
import { el } from '../layout';
import { compass8 } from './weatherTimeline';

export interface CompassModel {
  /** カメラの向き（北 0、時計回り、ラジアン） */
  cameraAzimuth: number;
  ground: { fromDeg: number; kmh: number };
  ridge: { fromDeg: number; kmh: number };
}

const SVG_NS = 'http://www.w3.org/2000/svg';

export function createCompass(host: HTMLElement): { render(m: CompassModel): void } {
  const root = el('div', 'compass');
  const svg = document.createElementNS(SVG_NS, 'svg');
  svg.setAttribute('viewBox', '-50 -50 100 100');
  svg.setAttribute('class', 'compass__dial');
  svg.innerHTML = `
    <circle r="44" class="compass__ring"/>
    <g class="compass__rose">
      <text y="-30" class="compass__n">N</text>
      <line y1="-44" y2="-38" class="compass__tick"/>
      <line x1="44" x2="38" class="compass__tick"/>
      <line y1="44" y2="38" class="compass__tick"/>
      <line x1="-44" x2="-38" class="compass__tick"/>
    </g>
    <g class="compass__wind"><line y1="26" y2="-22" class="compass__arrow"/><path d="M0,-30 L-8,-16 L8,-16 Z" class="compass__head"/></g>`;
  const rose = svg.querySelector('.compass__rose') as SVGGElement;
  const wind = svg.querySelector('.compass__wind') as SVGGElement;
  const text = el('div', 'compass__text');
  root.append(svg, text);
  host.appendChild(root);
  return {
    render(m) {
      const cam = (m.cameraAzimuth * 180) / Math.PI;
      rose.setAttribute('transform', `rotate(${-cam})`);
      // 風は吹いてくる方位の反対へ流れる
      wind.setAttribute('transform', `rotate(${m.ridge.fromDeg + 180 - cam})`);
      text.textContent = `地上 ${compass8(m.ground.fromDeg)} ${Math.round(m.ground.kmh)} ／ 稜線 ${compass8(m.ridge.fromDeg)} ${Math.round(m.ridge.kmh)} km/h`;
    },
  };
}
